export const encryptText = (input) => {
  if (!input) return input;

  try {
    return window.btoa(input);
  } catch (error) {
    return input;
  }
};

export const decryptText = (input) => {
  if (!input) return input;

  try {
    return window.atob(input);
  } catch (error) {
    return input;
  }
};
